<template>
  <iframe v-if="src" class="w-full h-full" :src="src" />
</template>

<script>
export default {
  name: 'HitTabIframe',

  props: {
    /**
     * URL of the html where to fetch the HTML file to display
     */
    src: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>
